module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tochd"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Preface"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Part1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part I: India to the War Office")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_P1Ch1"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])]), _vm._v(" From Cradle to the North-West Frontier")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_P1Ch2"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")])]), _vm._v(" The Somaliland Camel Corps")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_P1Ch3"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")])]), _vm._v(" 1920–1925, Staff Training and Marriage")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_P1Ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")])]), _vm._v(" 1925–1930, The Seats of Power")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_P1Ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")])]), _vm._v(" 1930–36, To India and Back to War Office")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_P1Ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")])]), _vm._v(" 1936–9, How Serious?")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part II: Second World War")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_P2Ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])]), _vm._v(" September 1939–May 1940, Chamberlain Years")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_P2Ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")])]), _vm._v(" May 1940 to May 1941, Disaster to Hope")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_P2Ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")])]), _vm._v(" June, 1941–1942, Three Problem Areas")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_P2Ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")])]), _vm._v(" 1943, The Year of Conferences")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_P2Ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")])]), _vm._v(" 1944, Overlord and More Conferences")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_P2Ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")])]), _vm._v(" 1945, Yalta and the End of the Road")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Part3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part III: India, Nato, and Other Posts")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_P3Ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])]), _vm._v(" 1947, Post War and India")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_P3Ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")])]), _vm._v(" 1948–1952, Some Minor Roles")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_P3Ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")])]), _vm._v(" 1952–7, Secretary General to NATO,")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/24_P3Ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")])]), _vm._v(" Retirement")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_P3Ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")])]), _vm._v(" Churchill and Pug")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_P3Ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")])]), _vm._v(" Contemporaries and their Insights")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_P3Ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7")])]), _vm._v(" Final Words on Pug Ismay")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Abbreviations",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Abbreviations")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14c103a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 66
// module chunks = 0